import { ACTIONS, SUBJECT } from "@/const/acl";

export const initialAbility = [
    {
        action: ACTIONS.READ,
        subject: SUBJECT.NON_AUTH
    },
    {
        action: ACTIONS.READ,
        subject: SUBJECT.FREE
    }
];

export const _ = undefined;
